import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Modal,
  TextField,
  Grid,
  FormControl,
  Link,
} from '@material-ui/core';
import _ from 'lodash';
import axios from 'axios';
import CustomSnackbar from '../../user/shared/CustomSnackbar';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    maxHeight: '100%',
    overflowY: 'auto',
    width: '50%',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  actions: {
    justifyContent: 'flex-end'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  photoContainer: {
    display: 'flex',
  },
  photoActionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  photo: {
    width: '100px',
    height: '100px',
  },
  sectionTitle: {
    margin: '20px 0',
    fontSize: '20px',
  },
}))

const PublisherForm = ({ adminUserSession, publisherId, onClose, open, afterCreatePublisher, onDataUpdate, itemIndex, ...props }) => {
  const classes = useStyles();

  const [publisher, setPublisher] = useState({
    name: '',
    photoPreview: '',
    photo: '',
  });

  const [errorMessage, setErrorMessage] = useState({});

  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [showSnackBar, setShowSnackBar] = useState(false);

  useEffect(() => {
    if (publisherId !== undefined && !_.isEmpty(adminUserSession)) {
      axios.get(
        `/v1/admin/publishers/${publisherId}/edit`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
      ).then((response) => {
        const {
          publisher,
          status: responseStatus
        } = response.data;

        const {
          ...itemParams
        } = publisher;

        setPublisher({
          ...itemParams,
          photoPreview: itemParams.photo_url || '',
        });
      }).catch(function (thrown) {
        console.log('error', thrown.message)
      });
    }
  }, [publisherId])

  const handleCreatePublisher = (publisher) => {
    let data = new FormData();
    data.append('publisher[name]', publisher.name);

    if (publisher.photoPreview != publisher.photo_url) {
      data.append('publisher[photo]', publisher.photo);
    }

    axios.post(
      `/v1/admin/publishers`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        },
      }
    ).then((response) => {
      const {
        data: {
          status,
          message,
          publisher,
        }
      } = response;

      if (status === 'success') {
        afterCreatePublisher(publisher);
        onClose();
      } else {
        setSnackBarMessage(message.photo);
        setShowSnackBar(true);
        console.log('message', message.photo)
      }
    })
  }

  const handleUpdatePublisher = (publisher) => {
    let data = new FormData();
    data.append('publisher[name]', publisher.name);

    if (publisher.photoPreview != publisher.photo_url) {
      data.append('publisher[photo]', publisher.photo);
    }

    axios.put(
      `/v1/admin/publishers/${publisherId}`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        status: statusUpdate,
        message,
        publisher,
      } = response.data;

      if (statusUpdate === 'success') {
        onDataUpdate(publisher, itemIndex);
      } else {
        setErrorMessage(message);
        console.log('message', message)
      }
    });
  }

  const handleOnChange = (event) => {
    event.persist();

    setPublisher(prevState => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  }

  const handleChangeFileInput = (event) => {
    event.persist();
    setPublisher(prevState => ({
      ...prevState,
      photo: event.target.files[0],
      photoPreview: event.target.files[0] ? URL.createObjectURL(event.target.files[0]) : publisher.photoPreview,
    }));
  }

  const handleSubmit = (event) => {
    event.persist();
    event.preventDefault();

    const blankValues = Object.keys(_.pickBy(publisher, (item) => ([null, undefined, ''].includes(item))));

    if (
      !_.isEmpty(_.intersection(blankValues, ['name']))
    ) {
      let message = {};

      blankValues.forEach((value) => {
        message[value] = "Can't be blank!"
      })

      setErrorMessage(message);
    } else if (publisherId !== undefined) {
      handleUpdatePublisher(publisher);
    } else {
      handleCreatePublisher(publisher);
    }
  }

  const handleCloseSnackBar = () => {
    setShowSnackBar(false);
    setSnackBarMessage('');
  }

  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card
        className={classes.root}
      >
        <CardHeader title='Publisher' />
        <Divider />
        <CardContent>
          <Grid container spacing={3} >
            <Grid
              item

              xs={4}
            >
              <span className={classes.photoContainer}>
                <img src={publisher?.photoPreview} className={classes.photo} />

                <div className={classes.photoActionsContainer}>
                  <input type='file' name='photo' onChange={handleChangeFileInput} />
                </div>
              </span>
            </Grid>

            <Grid
              item

              xs={8}
            >
              <FormControl fullWidth>
                <TextField
                  label="Name"
                  variant="outlined"
                  name='name'
                  required
                  inputProps={{ maxLength: 40 }}
                  value={publisher.name || ''}
                  onChange={handleOnChange}
                />
                <span>{errorMessage['name']}</span>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Button onClick={onClose}>Close</Button>
          <Button color="primary" variant="contained" onClick={handleSubmit}>Save</Button>
        </CardActions>

        {
          showSnackBar ?
            <CustomSnackbar
              open={showSnackBar}
              closeHandler={handleCloseSnackBar}
              message={snackBarMessage}
              options={{
                severity: 'success'
              }}
            />
            : null
        }
      </Card>
    </Modal>
  )
}

export default PublisherForm;